import React from "react";
import Heading from "../../../components/Heading";
import {useTranslation} from "react-i18next";
import SettingCard from "./SettingsCard"
import cx from "classnames";
import styles from './SettingOverview.module.css'

const SettingOverview: React.FC<{changeSettingsTab: (tab: string|null) => void}> = ({changeSettingsTab}) => {
    const { t } = useTranslation(['settings'])

    return (
        <>
            <Heading level={2} classes={'my-4'}>{t("common.settings")}</Heading>
            <div className={cx(styles['card-list'])}>
                <SettingCard
                    title={t('overview.button.heading')}
                    button={{title: t('overview.button.action'), action: () => {changeSettingsTab('button')}}}
                    text={t('overview.button.small_description')}
                />
                <SettingCard
                    title={t('overview.fonts.heading')}
                    button={{title: t('overview.fonts.action'), action: () => {changeSettingsTab('fonts')}}}
                    text={t('overview.fonts.small_description')}
                />
                <SettingCard
                    title={t('overview.media.heading')}
                    button={{title: t('overview.media.action'), action: () => {changeSettingsTab('media')}}}
                    text={t('overview.media.small_description')}
                />
                <SettingCard
                    title={t('overview.categories.heading')}
                    button={{title: t('overview.categories.action'), action: () => {changeSettingsTab('category')}}}
                    text={t('overview.categories.small_description')}
                />
            </div>
        </>
    )
}

export default SettingOverview
